export default __webpack_public_path__ + "static/media/user_poap_04.c45aa791.svg";